<template>
  <div
    ref="rightBarIcon"
    class="md:w-10 md:h-10 w-9 h-9 xl:hidden bg-primary-purple-50 button-shadow flex justify-center items-center cursor-pointer relative rounded-lg z-[11]"
    @click.prevent="mobileRightBar"
  >
    <icon :icon="rightBarToggleIcon" :color="iconColor" />
    <div v-if="tabRightNav || rightbarHidden" class="xl:hidden flex">
      <UiOnClickOutside :do="closeMobileRightBar">
        <RightBar
          :class="[
            {
              mobileRightBar: isMobileRightBar,
              'ltr:ml-0 rtl:mr-0': tabRightNav,
            },
          ]"
          :mobile-right-bar-height="mobileRightBarHeight"
          :right-bar-visibility="isMobileRightBar"
        />
      </UiOnClickOutside>
    </div>
  </div>
  <div
    v-if="tabRightNav && isMobileRightBar && isLaptopView"
    class="rightbar-overlay absolute"
  ></div>
</template>

<script>
import UiOnClickOutside from '@components/UiElements/UiOnClickOutside.vue'
import { mapState } from 'vuex'
import icon from '@components/icons/icon.vue'
import defaultLayout from '@/src/router/layouts/defaultLayout.json'

import RightBar from '@layouts/rightBar.vue'

export default {
  components: {
    RightBar,
    icon,
    UiOnClickOutside,
  },
  data() {
    return {
      mobileRightBarHeight: '',
    }
  },
  computed: {
    ...mapState({
      tabRightNav: (state) => state?.layout?.tabRightNav,
      isLaptopView: (state) => state?.layout?.isLaptopView,
    }),
    rightBarToggleIcon() {
      return this.tabRightNav ? 'doubleChevronLeft' : 'doubleChevronRight'
    },
    isMobileRightBar() {
      return this.rightbarHidden ? false : this.tabRightNav
    },
    rightbarHidden() {
      let isRightBarActive
      isRightBarActive = defaultLayout.rightBarHiddenFor.includes(this.$route?.name)
      if (!isRightBarActive)
        return (isRightBarActive = defaultLayout.RightBarActive.includes(this.$route?.path))
      return isRightBarActive
    },
    iconColor() {
      return this.tabRightNav ? 'primary-purple-700' : 'primary-gray-700'
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
    if (this.tabRightNav) {
      this.adjustAbsoluteDivHeight()
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.adjustAbsoluteDivHeight()
    },
    adjustAbsoluteDivHeight() {
      let parentContainer = this.$refs['rightBarIcon']
      if (parentContainer?.getBoundingClientRect) {
        let parentRect = parentContainer.getBoundingClientRect()
        let bottomOffset = window.innerHeight - parentRect.top - parentRect.height
        this.mobileRightBarHeight = String(bottomOffset - 50)
      }
    },

    mobileRightBar() {
      const isMobileView = window.matchMedia('(max-width: 1279px)').matches
      if (isMobileView && !this.tabRightNav) {
        this.adjustAbsoluteDivHeight()
        this.$store.commit('layout/SET_TAB_RIGHT_BAR', true)
      }
    },
    closeMobileRightBar() {
      if (this.isLaptopView && this.tabRightNav) {
        setTimeout(() => this.$store.commit('layout/SET_TAB_RIGHT_BAR', false), 0)
      }
    },
  },
}
</script>

<style scoped>
.rightbar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: var(--overlay);
  transition: 0.5s;
}
</style>
